const U = (id, w = 1600) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: "/images/session-stol.jpg",
  method: "/images/neurofeedback-software.jpg",
  session: "/images/session-skaerm.jpg",
  founder: "/images/ghazal-arbejde.jpg",
  trainingDetail: "/images/ghazal.jpg",
  childSession: "/images/barn-session.jpg",
  brainArt: "/images/traening-hovedtelefoner.jpg",
  overhead: "/images/traening-ovenfra.jpg",
  gudenaa: "/images/gudenaa.jpg",
  building: "/images/bygning.jpg",
};

export const NAV_LINKS = [
  { to: "/", label: "Forside", id: "nav-link-forside" },
  { to: "/hjerneregulering", label: "Hjerneregulering", id: "nav-link-hjerneregulering" },
  { to: "/neurofeedback", label: "Neurofeedback", id: "nav-link-neurofeedback" },
  { to: "/forloeb", label: "Forløb", id: "nav-link-forloeb" },
  { to: "/om", label: "Om", id: "nav-link-om" },
  { to: "/viden", label: "Viden", id: "nav-link-viden" },
  { to: "/kontakt", label: "Kontakt", id: "nav-link-kontakt" },
];

export const MARQUEE_ITEMS = [
  "Selvregulering",
  "Neuroplasticitet",
  "Neurofeedback",
  "Søvn",
  "Fokus",
  "Ro i nervesystemet",
  "Performance",
  "Mental udholdenhed",
];

// Booking: Calendly-bookingside (15 min indledende telefonsamtale).
// Alle booking-knapper på sitet peger hertil og åbner i nyt vindue.
export const BOOKING_URL = "https://calendly.com/ghazalsamii8/30";

// CVR: vises kun i footeren, når nummeret er udfyldt her.
export const CVR_NUMBER = "";

export const AREAS = [
  {
    title: "Fokus & opmærksomhed",
    desc: "Træning med fokus på vedvarende opmærksomhed og mental udholdenhed i skole, arbejde og hverdag.",
  },
  {
    title: "Søvn",
    desc: "Træning med fokus på nervesystemets evne til at falde til ro og finde dyb, restituerende søvn.",
  },
  {
    title: "Stress & belastning",
    desc: "Træning med fokus på kroppens alarmberedskab og vejen tilbage til ro efter pres.",
  },
  {
    title: "Følelsesmæssig regulering",
    desc: "Træning med fokus på fleksibilitet i mødet med stærke følelser og indre uro.",
  },
  {
    title: "Sensorisk regulering",
    desc: "Træning med fokus på regulering ved sensorisk overbelastning og overstimulering.",
  },
  {
    title: "ADHD & autisme",
    desc: "Træning med fokus på opmærksomhed, impulsstyring og regulering for børn og voksne.",
  },
  {
    title: "Performance",
    desc: "Træning med fokus på koncentration, restitution og mentalt overskud under pres.",
  },
  {
    title: "Generel hjernetræning",
    desc: "For dig, der vil passe på hjernen med samme omtanke, som du passer på kroppen.",
  },
];

export const ARTICLES = [
  {
    slug: "neuroplasticitet-i-praksis",
    category: "Neurovidenskab",
    readTime: "6 min læsning",
    date: "14. juli 2026",
    title: "Neuroplasticitet i praksis: Hvordan hjernen reorganiserer sig selv",
    excerpt:
      "I årtier troede man, at den voksne hjerne var fastlåst. I dag ved vi, at forbindelserne mellem nervecellerne tilpasser sig hele livet, og at vi kan bruge det bevidst.",
    image: U("photo-1642285230633-cf8012546f14"),
    imageCaption: "Hjernens netværk. Forbindelser, der formes af brug",
    sections: [
      {
        paragraphs: [
          "I store dele af 1900-tallet herskede der en forestilling om, at hjernen var færdigbygget, når barndommen var overstået. Skader og vaner var noget, man måtte leve med. Den forestilling er for længst afløst af en af neurovidenskabens vigtigste erkendelser: Hjernen er plastisk. Den ændrer sin struktur og funktion gennem hele livet, hver eneste dag.",
          "Neuroplasticitet er ikke et håb eller en metafor. Det er en målbar, biologisk egenskab. Når du lærer et nyt sprog, genkender et ansigt eller falder ind i en vane, er det netværk af nerveceller, der styrkes, svækkes og omorganiseres.",
        ],
      },
      {
        heading: "Hvordan hjernen lærer",
        paragraphs: [
          "Nerveceller, der aktiveres samtidig, knytter stærkere bånd til hinanden. I fagkredse kaldes det hebbiansk læring, en af flere veldokumenterede mekanismer bag hjernens plastiske tilpasninger. Gentager vi et mønster, styrkes de signalveje, mønsteret bruger. Lader vi være, svækkes de. Det gælder fysiske færdigheder, tankemønstre og stressreaktioner på tilsvarende måde.",
          "Det betyder også, at hjernen ikke skelner mellem ønsket og uønsket træning. Kronisk alarmberedskab er i princippet også en form for træning, et mønster der er blevet effektivt, fordi det er blevet gentaget. Det samme princip kan bruges i den modsatte retning.",
        ],
      },
      {
        heading: "Fra viden til træning",
        paragraphs: [
          "Neurofeedback anvender læring og gentagelse på en særlig måde. Sensorer registrerer hjernens elektriske aktivitet, og målte aspekter af EEG-aktiviteten omsættes til feedback gennem lyd eller billede i realtid. Feedbacken ændrer sig løbende i takt med hjernens tilstand og indgår i træningen af hjernens selvregulering.",
          "Træningen kræver ikke koncentration eller vilje i traditionel forstand. Pointen er, at målte aspekter af hjernens aktivitet, som vi normalt ikke har adgang til at mærke, bliver tilgængelige som feedback i realtid, og at tilpasningen får lov at ske gennem gentagelse over en række sessioner.",
        ],
      },
      {
        heading: "Hvad det betyder i praksis",
        paragraphs: [
          "Træning af hjernen sker gradvist, ligesom når kroppen trænes. Et forløb spænder over en række træninger, og nogle oplever ændringer tidligt, ofte i søvn eller ro, mens andre først mærker det i hverdagens krav.",
          "Neuroplasticitet er ikke en garanti for et bestemt resultat, og ærligheden om det er vigtig. Men det er en solid, videnskabelig grund til at tro på noget enkelt: Hjernen er ikke statisk. Den kan trænes.",
        ],
      },
    ],
  },
  {
    slug: "soevn-og-nervesystemets-restitution",
    category: "Søvn & restitution",
    readTime: "5 min læsning",
    date: "2. juli 2026",
    title: "Søvnens arkitektur: Hvad dagens regulering betyder for natten",
    excerpt:
      "Søvnbesvær er sjældent kun et natteligt problem. For nogle afspejler det et nervesystem, der ikke har fået lov at slippe dagen, men årsagerne kan være mange.",
    image: U("photo-1503891617560-5b8c2e28cbf6"),
    imageCaption: "Natten begynder længe før sengetid",
    sections: [
      {
        paragraphs: [
          "De fleste, der sover dårligt, leder efter løsningen om aftenen: mørklægning, rutiner, melatonin. Men søvn er ikke en tilstand, vi tænder for. Det er et mål, hjernen glider mod hele dagen. Evnen til at sove dybt begynder med nervesystemets evne til at skrue ned, mens det endnu er lyst.",
          "Hvis hjernen har stået i alarmberedskab fra morgen til aften, er overgangen til søvn som at træde på bremsen i fuld fart. Systemet kan godt, men det tager tid, og søvnen kan blive lettere og mere urolig, end den kunne være.",
        ],
      },
      {
        heading: "Søvnens arkitektur",
        paragraphs: [
          "Søvn bevæger sig i cyklusser gennem lettere og dybere faser. I den dybe søvn dominerer hjernens langsomme rytmer, og søvn er knyttet til vigtige restituerende processer: Hormoner reguleres, og immunforsvarets funktion påvirkes. Forskning peger desuden på, at det glymfatiske system, som medvirker til at fjerne affaldsstoffer fra hjernen, er mere aktivt under søvn end i vågen tilstand. Størstedelen af den viden stammer fra dyreforsøg, og systemet er ikke forbeholdt den dybe søvn alene.",
          "Den dybe søvn er ikke noget, vi kan tvinge frem. Sagt med et billede: Den kommer lettere, når nervesystemet har fået lov at slippe vagtholdet. Det er en metafor, ikke en bogstavelig beskrivelse af hjernens processer, men den rammer noget vigtigt om sammenhængen mellem ro og søvn. I samme billedsprog kan man sige, at søvn er et tillidsforhold mellem hjernen og omverdenen.",
        ],
      },
      {
        heading: "Når systemet ikke kan slippe dagen",
        paragraphs: [
          "Vedvarende stress kan holde det sympatiske nervesystem, kroppens gaspedal, aktivt langt ud på aftenen. Tankemylder, hjertebanken og den wired følelse ved sengetid kan være tegn på, at nervesystemet har svært ved at skrue ned. Søvnproblemer kan dog have mange årsager, biologiske, psykiske, adfærdsmæssige og medicinske, og regulering er kun ét af flere mulige perspektiver.",
          "Derfor kan det for nogle give mening at se ud over soveværelset og aftenrutinerne. Hvordan nervesystemet reguleres i døgnets lyse timer, kan spille ind på nætterne.",
        ],
      },
      {
        heading: "Regulering i døgnets lyse timer",
        paragraphs: [
          "Neurofeedback har til formål at træne hjernens evne til at regulere sin aktivering. Når træningen arbejder med hjernens regulering, mens vi er vågne, kan overgangen til søvnens langsomme rytmer for nogle blive lettere om aftenen. Nogle af dem, der træner, beretter om søvn som et af de første områder, de mærker en forskel på. Men neurofeedback er ikke en dokumenteret, universel løsning på søvnproblemer, og vedvarende søvnbesvær bør altid drøftes med din læge.",
          "Søvn er ikke en præstation. Den hænger sammen med hele døgnets regulering, og netop regulering er det, træningen arbejder med.",
        ],
      },
    ],
  },
  {
    slug: "fokus-adhd-og-opmaerksomhed",
    category: "Fokus & opmærksomhed",
    readTime: "7 min læsning",
    date: "21. juni 2026",
    title: "Koncentration, ADHD og hjernens rytmer: Hvorfor vilje sjældent er nok",
    excerpt:
      "Opmærksomhed er ikke et spørgsmål om at ville det nok. Det er et spørgsmål om, hvilken tilstand hjernen befinder sig i, når opgaven melder sig.",
    image: U("photo-1506880018603-83d5b814b5a6"),
    imageCaption: "Fokus er en tilstand, ikke en karakteregenskab",
    sections: [
      {
        paragraphs: [
          "Alle kender forskellen på en dag, hvor fokus kommer af sig selv, og en dag, hvor selv en enkel opgave føles som modvind. Forskellen ligger sjældent i motivationen. Den ligger i hjernens tilstand, i hvilke rytmer der dominerer, når vi sætter os for at koncentrere os.",
          "For mennesker med ADHD- eller ADD-relaterede udfordringer er den forskel ikke en daglig variation, men en vedvarende kamp. Og netop derfor er opmærksomhed et af de områder, hvor hjernetræning har længst historik.",
        ],
      },
      {
        heading: "Hjernens rytmer og opmærksomhed",
        paragraphs: [
          "Hjernens elektriske aktivitet bevæger sig i rytmer, fra meget langsomme til hurtige. I forskningen har man hos en del mennesker med ADHD og koncentrationsvanskeligheder set tendenser til, at visse målte rytmer adskiller sig fra gennemsnittet. Men det er vigtigt at være præcis: ADHD er heterogent, der findes ikke ét EEG-mønster, som beskriver alle med diagnosen, og EEG kan ikke bruges til at stille en diagnose.",
          "Uanset årsagen står mange tilbage med samme oplevelse: Vilje alene rækker sjældent. Man kan ikke tænke sig ud af en tilstand, man først skal kunne regulere sig ud af.",
        ],
      },
      {
        heading: "Træning frem for vilje",
        paragraphs: [
          "Neurofeedback giver hjernen løbende feedback om sin egen aktivitet i realtid. Feedbacken indgår i træningen af hjernens selvregulering, som over tid kan styrke evnen til at finde og fastholde en opmærksom tilstand.",
          "Målet er ikke at ændre et menneske, men at arbejde med en evne: at kunne tænde for opmærksomheden, når den skal bruges, og slippe den igen, når den ikke skal.",
        ],
      },
      {
        heading: "Hvad siger forskningen?",
        paragraphs: [
          "ADHD og opmærksomhed er blandt de områder, hvor neurofeedback er mest undersøgt. Forskningen viser lovende resultater, men evidensen varierer mellem metoder, studiedesign og problemstillinger, og resultaterne er forskellige fra person til person.",
          "Hos Center for Hjerneregulering betragtes neurofeedback som træning, ikke som erstatning for medicin, terapi eller skolestøtte. Har du eller dit barn en diagnosticeret udfordring, skal du altid drøfte træningen med din læge eller behandler. Ærligheden om, hvad metoden kan og ikke kan, er en del af selve metoden.",
        ],
      },
    ],
  },
  {
    slug: "stress-og-nervesystemets-alarm",
    category: "Stress & belastning",
    readTime: "6 min læsning",
    date: "10. juni 2026",
    title: "Når alarmen ikke slukker: Stress, nervesystemet og hjernens bremse",
    excerpt:
      "Kronisk overbelastning er ikke bare travlhed. For nogle kan det føles, som om nervesystemet har glemt, hvordan det er at være trygt nok til at hvile.",
    image: U("photo-1468657988500-aca2be09f4c6"),
    imageCaption: "Nervesystemet kan arbejde med ro gennem gentagelse",
    sections: [
      {
        paragraphs: [
          "Stressresponsen er i sig selv et mesterværk. Når hjernen registrerer en trussel, sætter den kroppen i beredskab på sekunder: puls op, opmærksomhed tilspidset, muskler klar. Problemet opstår, når beredskabet aldrig får besked om at stå ned igen.",
          "Vedvarende pres fra arbejde, bekymringer, sensorisk støj og for lidt søvn kan fastholde hjernen i en tilstand, hvor alarmen bliver standardindstillingen. Det mærkes som uro i kroppen, kort lunte, søvn der ikke vil komme, og en hverdag, hvor selv små krav føles store.",
        ],
      },
      {
        heading: "Hjernens alarm og dens bremse",
        paragraphs: [
          "Dyb i hjernen sidder amygdala, alarmsystemet der reagerer hurtigere, end vi kan tænke. Dets modpart er blandt andet præfrontal cortex, der kan vurdere situationen og dæmpe alarmen, når den ikke er nødvendig. Ved langvarig belastning kan balancen tippe. Alarmen bliver følsom, og bremsen bliver træt.",
          "Det er ikke en svaghed eller et personlighedstræk. Det er en regulering, der midlertidigt er kommet ud af balance, og regulering kan trænes.",
        ],
      },
      {
        heading: "Når bremsen skal genlæres",
        paragraphs: [
          "Neurofeedback arbejder med præcis det: hjernens evne til at regulere sin egen aktivering. Gennem rolige træningsforløb arbejdes der med bevægelsen fra beredskab mod ro, gang efter gang.",
          "Træningen sker ikke ved at tale om stress, men ved at arbejde direkte med nervesystemets regulering. For nogle er det første tegn på forandring ikke dramatisk. Det kan være en aften, hvor kroppen falder til ro lidt hurtigere end i går.",
        ],
      },
      {
        heading: "Et ærligt perspektiv",
        paragraphs: [
          "Hjernetræning kan understøtte stressregulering, men det fjerner ikke stressens årsager, og det skal det heller ikke. Et forløb hos Center for Hjerneregulering går hånd i hånd med det, du selv gør for din hverdag. Og ved svær stress eller udbrændthed bør træningen altid ses som et supplement til, aldrig en erstatning for, lægelig og psykologisk hjælp.",
        ],
      },
    ],
  },
  {
    slug: "performance-og-flow",
    category: "Performance",
    readTime: "5 min læsning",
    date: "28. maj 2026",
    title: "Performance og flow: At træne hjernens evne til at regulere sig under pres",
    excerpt:
      "De bedste præstationer sker sjældent i højeste gear. De sker i den tilstand, hvor hjernen er skarp, rolig og fuldstændig til stede.",
    image: "/images/artikel-performance-trin.jpg",
    imageCaption: "Præstation begynder i hjernens tilstand",
    sections: [
      {
        paragraphs: [
          "Flow-tilstanden, følelsen af at være helt inde i det, man laver, er ikke mystisk. I forskningen beskrives den som en tilstand, hvor opmærksomheden er stabil, og hvor handling og opmærksomhed smelter sammen. Atleter, musikere og beslutningstagere kender den alle, men de færreste træner den direkte.",
          "Vi træner teknik, taktik og fysik. Men den tilstand, det hele skal afleveres i, overlader vi ofte til tilfældighederne.",
        ],
      },
      {
        heading: "Hjernen under pres",
        paragraphs: [
          "Pres ændrer hjernens rytmer. Ved for høj aktivering kan opmærksomheden smalne, finmotorikken lide, og beslutninger kan blive reaktive. Ved for lav aktivering kan skarpheden mangle. Præstation hænger ofte sammen med at ramme det rette niveau af aktivering, og det niveau er ikke det samme for en sælger, en svømmer og en kirurg.",
          "At kende sin egen hjerne under pres er derfor et konkurrenceparameter i sig selv. Restitution er det andet. Evnen til at komme ned i gear efter præstationen afgør, hvor længe man kan blive ved.",
        ],
      },
      {
        heading: "Regulering frem for maksimering",
        paragraphs: [
          "Neurofeedback bruges af eliteatleter, musikere og erhvervsledere verden over som en del af deres mentale træning. Formålet er ikke at maksimere, men at regulere: at arbejde med hjernens evne til at tilpasse aktivering og opmærksomhed efter opgaven og skrue ned igen bagefter. Målet er fleksibilitet, ikke en garanteret optimal tilstand.",
          "Hos Center for Hjerneregulering er performance ikke et adskilt spor fra det øvrige arbejde. Det er den samme grundlæggende evne, selvregulering, trænet med et andet mål. Om du vil sove bedre eller præstere skarpere, er det samme hjerne, der skal arbejde med sin regulering.",
        ],
      },
    ],
  },
];
